/* SITRA Soft Club — theme.js */
(function () {
  'use strict';

  var SC = window.SoftClub || { routes: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('#CartToast');
    if (!el) return;
    $('[data-toast-text]', el).textContent = msg;
    el.classList.toggle('toast--error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    return fetch((SC.routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-add]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btns = $$('button[type=submit]', form).concat($$('button[form="' + form.id + '"]'));
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var body = new FormData(form);
    fetch((SC.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to bag');
        toast('Added to your bag');
        return refreshCartCount();
      })
      .catch(function (err) { toast(err.message || 'Something went wrong', true); })
      .finally(function () {
        btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; });
        var pdp = form.closest('[data-pdp]');
        if (pdp && pdp.__sync) pdp.__sync();
      });
  });

  /* ---------- Mobile nav ---------- */
  var nav = $('[data-mobile-nav]');
  if (nav) {
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.open) { nav.open = false; $('summary', nav).focus(); } });
    document.addEventListener('click', function (e) { if (nav.open && !nav.contains(e.target)) nav.open = false; });
    nav.addEventListener('toggle', function () { document.body.style.overflow = nav.open ? 'hidden' : ''; });
  }

  /* ---------- Delivery dates ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime()); var added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  }
  function fmt(d, short) {
    return d.toLocaleDateString('en-US', short ? { month: 'short', day: 'numeric' } : { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (root.__init) return; root.__init = true;
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var style = root.dataset.style;

    // Delivery estimate
    var pMin = +root.dataset.procMin || 0, pMax = +root.dataset.procMax || 0;
    var tMin = +root.dataset.transitMin || 0, tMax = +root.dataset.transitMax || 0;
    var now = new Date();
    var delA = addBusinessDays(now, pMin + tMin), delB = addBusinessDays(now, pMax + tMax);
    var shipA = addBusinessDays(now, pMin), shipB = addBusinessDays(now, pMax);
    $$('[data-deliver-range]', root).forEach(function (el) {
      el.textContent = style === 'editorial' ? fmt(delA) + ' – ' + fmt(delB) : fmt(delA, true) + ' – ' + fmt(delB, true);
    });
    $$('[data-ship-range]', root).forEach(function (el) { el.textContent = fmt(shipA, true) + ' – ' + fmt(shipB, true); });
    $$('[data-today]', root).forEach(function (el) { el.textContent = fmt(now); });

    // Gallery
    var track = $('[data-track]', root);
    var slides = $$('.pdp__slide', root);
    var thumbs = $$('.pdp__thumb', root);
    var counter = $('[data-counter]', root);
    function isScroller() { return track && track.scrollWidth > track.clientWidth + 4; }
    function currentIndex() {
      if (!isScroller()) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function markThumb(id) {
      thumbs.forEach(function (t) {
        var on = t.dataset.media === String(id);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 24, behavior: 'smooth' });
      });
      if (counter) {
        var ordered = $$('.pdp__slide', root);
        var idx = ordered.findIndex(function (s) { return s.dataset.media === String(id); });
        counter.textContent = (idx + 1) + ' / ' + ordered.length;
      }
    }
    function show(id) {
      if (!id) return;
      var slide = slides.filter(function (s) { return s.dataset.media === String(id); })[0];
      if (!slide) return;
      if (isScroller()) {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      } else if (track.firstElementChild !== slide) {
        track.insertBefore(slide, track.firstElementChild);
      }
      markThumb(id);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.media); }); });
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    function step(dir) {
      var ordered = $$('.pdp__slide', root);
      var i = (currentIndex() + dir + ordered.length) % ordered.length;
      show(ordered[i].dataset.media);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          if (!isScroller()) return;
          var s = $$('.pdp__slide', root)[currentIndex()];
          if (s) markThumb(s.dataset.media);
        }, 80);
      }, { passive: true });
      var first = slides.filter(function (s) { return s.classList.contains('is-on'); })[0] || slides[0];
      if (first) { setTimeout(function () { show(first.dataset.media); }, 50); }
    }

    // Variant selection
    var input = $('[data-variant-input]', root);
    var current = variants.filter(function (v) { return input && String(v.id) === input.value; })[0] || variants[0];
    var sel = current ? current.o.slice() : [];
    var priceEl = $('[data-price]', root), wasEl = $('[data-was]', root), stockEl = $('[data-stock]', root);
    var atc = $('[data-atc]', root), atcLabel = $('[data-atc-label]', root);
    var stickyBtn = $('[data-sticky-btn]', root), stickyPrice = $('[data-sticky-price]', root);
    var stickyVariant = $('[data-sticky-variant]', root), atcPrice = $('[data-atc-price]', root);
    var optBtns = $$('[data-opt]', root);

    function match() {
      return variants.filter(function (v) { return v.o.every(function (val, i) { return val === sel[i]; }); })[0];
    }
    function refreshAvailability() {
      optBtns.forEach(function (b) {
        var idx = +b.dataset.opt;
        var ok = variants.some(function (v) {
          if (v.o[idx] !== b.dataset.value || !v.a) return false;
          return v.o.every(function (val, i) { return i === idx || val === sel[i]; });
        });
        b.classList.toggle('is-na', !ok);
      });
    }
    function sync() {
      var v = match();
      refreshAvailability();
      var available = !!(v && v.a);
      if (v) {
        current = v;
        if (input) input.value = v.id;
        if (priceEl) priceEl.textContent = v.p;
        if (stickyPrice) stickyPrice.textContent = v.ps;
        if (atcPrice) atcPrice.textContent = v.ps;
        if (stickyVariant && v.t !== 'Default Title') stickyVariant.textContent = v.t;
        if (wasEl) { if (v.c) { wasEl.textContent = v.c; wasEl.hidden = false; } else { wasEl.hidden = true; } }
        try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString()); } catch (e) {}
      }
      if (stockEl) { stockEl.textContent = !v ? 'Unavailable' : (v.a ? 'In stock' : 'Sold out'); stockEl.classList.toggle('is-out', !available); }
      if (atc) atc.disabled = !available;
      if (stickyBtn) stickyBtn.disabled = !available;
      if (atcLabel) atcLabel.textContent = !v ? 'Unavailable' : (v.a ? 'Add to bag' : 'Sold out');
      updateShipBar();
      return v;
    }
    root.__sync = sync;
    optBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = +b.dataset.opt;
        $$('[data-opt="' + idx + '"]', root).forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        sel[idx] = b.dataset.value;
        var nameEl = $('[data-opt-name="' + idx + '"]', root) || (b.classList.contains('swatch') ? $('[data-color-name]', root) : null);
        if (nameEl) nameEl.textContent = b.dataset.value;
        var v = sync();
        if (b.dataset.media) show(b.dataset.media); else if (v && v.m) show(v.m);
      });
    });
    refreshAvailability();

    // Free shipping bar (Clean Tabs)
    function updateShipBar() {
      var bar = $('[data-ship-bar]', root), msg = $('[data-ship-msg]', root);
      if (!bar) return;
      var threshold = +root.dataset.threshold || 0;
      var cartTotal = +root.dataset.cartTotal || 0;
      if (!threshold) return;
      var pct = Math.min(100, Math.round(cartTotal / threshold * 100));
      bar.style.width = pct + '%';
      var remaining = threshold - cartTotal;
      if (msg) msg.textContent = remaining > 0
        ? 'Add ' + formatMoney(remaining) + ' more to your bag for free shipping'
        : "You've unlocked free US shipping";
    }
    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
    updateShipBar();
    root.addEventListener('submit', function () {
      setTimeout(function () {
        refreshCartCount().then(function (cart) { root.dataset.cartTotal = cart.total_price; updateShipBar(); });
      }, 900);
    });

    // Qty
    var q = $('[data-qty]', root);
    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    if (q && minus) minus.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    if (q && plus) plus.addEventListener('click', function () { q.value = (parseInt(q.value, 10) || 1) + 1; });

    // Tabs
    var tabs = $('[data-tabs]', root);
    if (tabs) {
      var tabBtns = $$('[role=tab]', tabs);
      function activate(btn) {
        tabBtns.forEach(function (t) {
          var on = t === btn;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
        });
      }
      tabBtns.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = tabBtns[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabBtns.length) % tabBtns.length];
          n.focus(); activate(n);
        });
      });
    }

    // Sticky add to bag on phones
    var sticky = $('[data-sticky-atc]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        sticky.classList.toggle('is-visible', !hidden);
        sticky.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        if (stickyBtn) stickyBtn.tabIndex = hidden ? -1 : 0;
      }).observe(atc);
    }
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations(el) {
    if (el.__init || !el.dataset.url) return; el.__init = true;
    if (el.querySelector('.product-rail')) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Collection ---------- */
  function initCollection(root) {
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
    var filters = $('[data-filters]', root);
    if (filters && window.matchMedia('(min-width: 990px)').matches) filters.open = true;
  }

  /* ---------- Cart ---------- */
  function initCart() {
    var form = $('#CartForm');
    if (!form) return;
    var t;
    $$('[data-cart-qty]', form).forEach(function (inp) {
      inp.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () {
        var btn = form.querySelector('[data-cart-update]');
        if (form.requestSubmit && btn) form.requestSubmit(btn); else form.submit();
      }, 400); });
    });
  }

  function boot() {
    $$('[data-pdp]').forEach(initProduct);
    $$('[data-recommendations]').forEach(initRecommendations);
    $$('[data-collection]').forEach(initCollection);
    initCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
